export const apiKeyGetAddressOrganization = 'api/next/counterparty/suggestions/addresses';
export const defaultUrlGetAddressOrganization = 'api/v1/counterparty/suggestions/addresses';

export const apiKeyGetOrganization = 'api/next/service-connection/organizations/agents';
export const defaultUrlGetOrganization = 'api/v1/service-connection/organizations?productType=AGENTS';

export const apiKeyAutocompleteOrganizations = 'api/next/user/autocomplete/organizations';
export const defaultUrlAutocompleteOrganizations = 'api/v1/autocomplete/organizations';